// extracted by mini-css-extract-plugin
export default {"paginationContainer":"+h6l0wSemeo3yCQUCntUOw==","noProjectsHint":"eDVd2LQE5E64Y1hFjqlkCQ=="};